import { For, type Accessor } from 'solid-js';
import {
  CREW_TAG_EDIT_FIELDS,
  type CrewTagEditField,
  type CrewTagEditValues,
} from '@utils/crewCode';

export default function TagsExploreEditCrewFields(props: {
  values: Accessor<CrewTagEditValues>;
  setField: (key: CrewTagEditField, value: string) => void;
}) {
  return (
    <div class="tags-explore-edit-modal__crew-fields">
      <For each={CREW_TAG_EDIT_FIELDS}>
        {(field) => (
          <div class="tagger-field">
            <label for={`tags-explore-edit-crew-${field.key}`}>{field.label}</label>
            <input
              id={`tags-explore-edit-crew-${field.key}`}
              type="text"
              class="tagger-datetime-input"
              value={props.values()[field.key]}
              onInput={(e) => props.setField(field.key, e.currentTarget.value)}
            />
          </div>
        )}
      </For>
    </div>
  );
}
